// First API Layer of claim module
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
// centralise all mutations
import {
  CLAIMS_RI_RECOVERIES_INIT_LOADING,
  CLAIMS_RI_RECOVERIES_INIT_SUCCESS,
  CLAIMS_RI_RECOVERIES_INIT_FAIL
} from '@/store/types'

export const clmRIRcvy = {
  async clmRIRcvyInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.claimsRIRecoveriesManagement
    if (apiUrl) {
      commit(CLAIMS_RI_RECOVERIES_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(CLAIMS_RI_RECOVERIES_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMS_RI_RECOVERIES_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(CLAIMS_RI_RECOVERIES_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  }
}
